import PromoView from "compid/shared/views/PromoView";
import React from "react";
import "./styles.css";


export default function PromoeBillsView(props) {
  const icon = props.icon;
  return (
    <div className="promo-ebills-view">
      <PromoView
        icon={icon}
        title="Looking for more convenience?"
        description="Get your electronic statements and payment reminders here with eBills."
        text="Get eBills"
        onClick={ props.onClick }
        dataPoint="Promo_Ebill_Chevron"
      />
    </div>
  );
}
